import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { DashboardNavbar } from '../components/Navbars';
import { DashboardFooter } from '../components/Footers';
import { PropertyContext, PropertyProvider } from '../context/PropertyContext';
import { useDocumentTitle } from '../hooks';
import { AccessProvider } from '../context/AccessContext';
import {
  Routes as AppRoutes,
  protectedAreaBasePath,
} from '../router/routeMapping';
// import { FirebaseNotification } from '../components';

const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '';

const forcePath = AppRoutes.protected.PROPERTY_FIRST_CREATE.path;

function AccessContextWrapper({ children }) {
  const { properties } = useContext(PropertyContext);

  const getLink = (val) => (
    <Link to={forcePath} className="alert-link">
      {val}
    </Link>
  );

  return (
    <AccessProvider
      forcePath={forcePath}
      forcePathMessage={
        <FormattedMessage
          id="app.common.forcePathInfoMessage"
          values={{
            a: getLink,
          }}
        />
      }
      returnPath={protectedAreaBasePath}
      allowedPaths={[
        AppRoutes.protected.ACCOUNT.path,
        ...Object.values(AppRoutes.protected.ACCOUNT.children).map(
          ({ path }) => path
        ),
      ]}
      hasAccess={properties.length > 0}
    >
      {children}
    </AccessProvider>
  );
}

AccessContextWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

function Dashboard({ children }) {
  useDocumentTitle();

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <PropertyProvider>
        <AccessContextWrapper>
          <div className="footer-offset">
            <DashboardNavbar />
            <main id="content" role="main" className="main">
              {children}
              <DashboardFooter />
            </main>
          </div>
        </AccessContextWrapper>
      </PropertyProvider>
    </GoogleOAuthProvider>
  );
}

Dashboard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Dashboard;
